const toggle = document.querySelector<HTMLElement>(".masthead-toggle");

if (toggle) {
    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const target = (e.target as HTMLElement).closest<HTMLElement>('.masthead')!;
        if (target.classList.contains('masthead-nav--open')) {
            enableBodyScrolling();
        } else {
            disableBodyScrolling();
        }

        // toggle
        target.classList.toggle('masthead-nav--open');
    });


    // story scroll effect
    window.addEventListener('scroll', () => {
        if (window.scrollY > 4) {
            document.body.classList.add('body-scrolled');
        } else {
            document.body.classList.remove('body-scrolled');
        }
    });
}

// page-sidenav
const trigger = document.querySelector<HTMLElement>(".page-sidebar-mobile-toggle");

if (trigger) {
    const wrapper = trigger.closest<HTMLElement>('.page-sidebar')!;
    const list = wrapper?.querySelector<HTMLElement>("ul")!;
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        // expand
        if (!wrapper.classList.contains('page-sidebar-expanded')) {
            list.style.height = `${list.scrollHeight}px`;
            wrapper.classList.add('page-sidebar-expanded');
        } else {
            // height
            list.style.height = `${list.scrollHeight}px`;
            wrapper.classList.remove('page-sidebar-expanded');
            list.removeAttribute('style');
        }
    });
    // update page heading
    const heading = wrapper?.querySelector<HTMLElement>(".page-sidebar-mobile-heading")!;
    const activeItem = wrapper?.querySelector<HTMLElement>("li.active")!;
    if (activeItem) {
        heading.textContent = activeItem.textContent;
    }

}


function disableBodyScrolling() {
    const documentScrollY = window.scrollY;
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${documentScrollY}px`;
    body.dataset['scroll'] = documentScrollY.toString();
}
function enableBodyScrolling() {
    const body = document.body;
    const documentScrollY = parseFloat(body.dataset['scroll'] || '0');
    body.style.position = '';
    body.style.top = '';
    window.scrollTo({
        top: documentScrollY,
        left: 0,
        behavior: 'instant'
    });
}

export default undefined;